export default __webpack_public_path__ + "static/media/placeholder-content-img.7957f6ed.png";